<template>
  <div class="container-fluid" v-if="isAuthLv2">
    <div class="row justify-content-center">
      <form
        class="form-horizontal "
        role="form"
      >
      <div class="row">
        <div class="col-md-12">
            <label
              for="purchasetype"
              class="mr-4 control-label"
            >Purchase Type</label>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="purchasetype"
                id="purchasetype_ST"
                value="ST"
                v-model="purchasetype"
                :v="$v.purchasetype"
              />
              <label
                class="form-check-label"
                for="purchasetype_ST"
              >MEMBERSHIP</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="purchasetype"
                id="purchasetype_PD"
                value="PD"
                v-model="purchasetype"
                :v="$v.purchasetype"
              />
              <label
                class="form-check-label"
                for="purchasetype_PD"
              >PRODUCT</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="purchasetype"
                id="purchasetype_FR"
                value="FR"
                v-model="purchasetype"
                :v="$v.purchasetype"
              />
              <label
                class="form-check-label"
                for="purchasetype_FR"
              >FREE</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="purchasetype"
                id="purchasetype_AL"
                value="AL"
                v-model="purchasetype"
                :v="$v.purchasetype"
              />
              <label
                class="form-check-label"
                for="purchasetype_AL"
              >ALL</label>
            </div>
          </div>
      </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group form-inline d-flex justify-content-center">
              <label
                for="start_date"
                class="control-label mr-3"
              >Start Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="start_date"
                  valueType="format"
                ></date-picker>
              </div>

              <label
                for="end_date"
                class="control-label mr-3"
              >End Date</label>
              <div class="mr-3">
                <date-picker
                  v-model="end_date"
                  valueType="format"
                ></date-picker>
              </div>
              <b-button
                variant="success"
                @click.prevent="exportExcel"
                :class="{ invalid: $v.$invalid }"
              >Export</b-button>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>
  <div v-else>
<div class="row justify-content-center">
  <h1>No Permission</h1>
</div>
  </div>
</template>
<script>
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import XLSX from "xlsx"; // import xlsx
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { validationMixin } from "vuelidate";
import {
  required,
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      start_date: new Date().toISOString().substring(0, 10),
      end_date: new Date().toISOString().substring(0, 10),
      purchasetype:null,
      items: null,
      json: [
        { name: "Dady", age: "21" },
        { name: "Jonh", age: "25" },
        { name: "James", age: "17" },
      ],
    };
  },
  components: {
    DatePicker
  },
  validations: {
    purchasetype: {
      required
    },
  },
  computed: {
    isAuthLv2
  },
  mounted() {},
  methods: {
    async exportExcel() {

      if (this.purchasetype == null) {
        return false;
      }

      //this.start_date = '2021-05-01';
      //this.end_date = '2021-05-30';
      let self = this;
      if (this.start_date !== null && this.end_date !== null) {
        this.loading = true;
        await axios
          .post("/api/purchases/exportexcel", {
            from: this.start_date,
            to: this.end_date,
            purchasetype: this.purchasetype,
          })
          .then(response => {
            //console.log(response.data);
            //this.items = JSON.parse(response.data);
            //this.items = JSON.parse(response.data);
            this.items = response.data.data;
            
            const dataWS = XLSX.utils.json_to_sheet(this.items);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "export_"+self.purchasetype+".xlsx");


            this.loading = false;
          });
      }
    },
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.json);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
  },
};
</script>
<style scoped>
</style>
